import type { ReactNode } from "react";

import { DeferredCommitStatusGlyph } from "./DeferredCommitStatusGlyph";

export function DeferredCommitFieldFrame({
  label,
  isDirty,
  disabled,
  pending,
  commitError,
  commitSucceeded,
  unsavedHint,
  savedHint,
  statusGlyphClassName,
  showOverlayGlyph,
  children,
}: {
  label?: ReactNode;
  isDirty: boolean;
  disabled: boolean;
  pending?: boolean;
  commitError?: string | null;
  commitSucceeded?: boolean;
  unsavedHint?: string;
  savedHint?: string;
  statusGlyphClassName?: string;
  showOverlayGlyph: boolean;
  children: ReactNode;
}): JSX.Element {
  const glyph = (
    <DeferredCommitStatusGlyph
      pending={pending}
      isDirty={isDirty}
      disabled={disabled}
      commitError={commitError}
      commitSucceeded={commitSucceeded}
      unsavedHint={unsavedHint}
      savedHint={savedHint}
      className={label ? statusGlyphClassName : undefined}
    />
  );

  return (
    <div className="min-w-0">
      {label ? (
        <div className="mb-1.5 flex min-h-5 items-center gap-1">
          {label}
          {glyph}
        </div>
      ) : null}
      <div className="relative min-w-0">
        {children}
        {showOverlayGlyph && !label ? (
          <div className="pointer-events-none absolute right-1 top-1.5 z-10">
            <div className="pointer-events-auto">{glyph}</div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
